import * as React from 'react';

import Editor from '../Editor/Editor';
import { ErrorBoundary } from '../ErrorBoundary';

const Simulate = () => (
  <ErrorBoundary showUI={true} isNotFullScreen={true}>
    <Editor />
  </ErrorBoundary>
);

export default Simulate;
